import { Component, Input, OnInit } from '@angular/core';
import { Keyboard } from '@ionic-native/keyboard/ngx';
import { AlertController, LoadingController, ModalController, NavController, NavParams, Platform, ToastController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ClubHandicap, HandicapCalculation } from 'src/data/handicap-history';
import { ClubInfo, ClubMembership, ClubMembershipExtended, ClubMembershipType, PlayerGroup, PlayerGroupList, PlayerHomeInfo, PlayerInfo } from 'src/data/mygolf.data';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { HandicapService } from 'src/providers/handicap-service/handicap-service';
import { PlayerService } from 'src/providers/player-service/player-service';
import { PlayerHomeActions, PlayerHomeDataService } from 'src/redux/player-home';
import { ClubListPage } from '../../normalgame/club-list/club-list.page';
import { PlayerAddClubMembershipPage } from '../player-add-club-membership/player-add-club-membership.page';
import { Router } from '@angular/router';
import { TrasactionModalComponent } from '../../modal-screens/player-refund-redeem-history/trasaction-modal/trasaction-modal.component';
import { DeleteRoomModalComponent } from '../../package-details/package-booking/delete-room-modal/delete-room-modal.component';
import { CommonPullupMenuComponent } from '../../modal-screens/common-pullup-menu/common-pullup-menu.component';

@Component({
  selector: 'app-player-list-club-membership',
  templateUrl: './player-list-club-membership.page.html',
  styleUrls: ['./player-list-club-membership.page.scss'],
})
export class PlayerListClubMembershipPage implements OnInit {

  refreshing: boolean = true;
  playerHomeInfo$: Observable<PlayerHomeInfo>;
  player$: Observable<PlayerInfo>;
  public playerGroupList: PlayerGroupList;
  public selectAndReturn: boolean = false;
  public selectedGroup: PlayerGroup;

  public handicapHistory: HandicapCalculation;
  public clubHandicap: Array<ClubHandicap>;
  public playerClubHcp: any;
  public hasM2u: boolean = false;
  public memberships: Array<ClubMembershipExtended> = [];
  public clubIds: Array<number> = [];
  public statusGetHCP: boolean = false;
  playerHcpSystem: string;

  filteredClubType: string = 'golfClub';

  @Input() addNew: boolean = false;
  @Input() init: boolean = true;

  constructor(
    private nav: NavController,
    private alertCtl: AlertController,
    private loadingCtl: LoadingController,
    private modalCtl: ModalController,
    private toastCtl: ToastController,
    private navParams: NavParams,
    private playerService: PlayerService,
    private keyboard: Keyboard,
    private platform: Platform,
    private handicapService: HandicapService,
    private playerHomeService: PlayerHomeDataService,
    private playerHomeActions: PlayerHomeActions,
    private flightService: ClubFlightService,
    private router: Router,
  ) {
    this.playerGroupList = {
      success: true,
      playerGroups: []
    };
    if (this.router.getCurrentNavigation()) {
      this.player$ = this.router.getCurrentNavigation().extras.state.player;
      this.selectAndReturn = this.router.getCurrentNavigation().extras.state.selectAndReturn;
    }
    else {
      this.selectAndReturn = navParams.get("selectAndReturn");
      this.player$ = navParams.get('player');
    }
    this.playerHomeInfo$ = this.playerHomeService.playerHomeInfo();
    if (!this.player$) {
      this.player$ = this.playerHomeInfo$.pipe(map((playerHomeInfo: PlayerHomeInfo) => playerHomeInfo.player));
    }

  }

  ngOnInit() {
    this._refreshMemberships(null,null,this.init);
  }

  ionViewDidEnter() {
    if(this.addNew) {
      this.openAddClubMembership();
    }
  }
  ionViewWillEnter() {
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      this.playerHcpSystem = player.defaultHandicapSystem
    });
  }

  onGroupSelection(event, group) {
    // this.events.publish("playerGroupSelected", group);
    if (this.selectAndReturn) {
      this.modalCtl.dismiss(group);
      // this.nav.pop();
    }

  }

  async onDeleteFlightClick(event, group: PlayerGroup) {
    let confirm = await this.alertCtl.create({
      header: "Delete Player Group",
      message: "Do you want to delete the player group " + group.groupName + "?",
      buttons: [{
        text: "No",
        role: "cancel",
        handler: () => {
          confirm.dismiss();
          return false;
        }
      }, {
        text: "Yes",
        handler: () => {
          confirm.dismiss().then(() => {
            this.deleteGroup(group);
          });
          return false;
        }
      }]
    });
    confirm.present();
  }

  async deleteGroup(group: PlayerGroup) {
    let loading = await this.loadingCtl.create({
      showBackdrop: false
    });
    loading.onDidDismiss().then((refresh: any) => {
      if (refresh)
        this._refreshPlayerGroups();
    });
    this.playerService.deletePlayerGroup(group.id)
      .subscribe((result: boolean) => {
        loading.dismiss(result);
      }, (error) => {
        loading.dismiss(false);
      });
    loading.present();
  }

  cancelGroup() {
    this.modalCtl.dismiss(false);
  }

  _selectClubMembership(clubMembership: ClubMembershipExtended) {
    console.debug("selecting club membership : ", clubMembership)
    if (!clubMembership) {
      // MessageDisplayUtil.displayInfoAlert(this.alertCtl, "Success",
      // "Handicap updated", "OK");
      MessageDisplayUtil.showErrorToast("Please re-select club", this.platform, this.toastCtl,
        5000, "bottom");
      return false;
    }
    this.modalCtl.dismiss(clubMembership);
  }

  private _refreshPlayerGroups() {
    this.refreshing = true;
    this.playerService.getPlayerGroups()
      .subscribe((pgList: PlayerGroupList) => {
        this.playerGroupList = pgList;
        this.refreshing = false;
      }, (error) => {
        console.error(error);
        this.refreshing = false;
      })
  }


  private async _refreshMemberships(busy?: any, refresher?, init?: boolean) {

    this.refreshing = true;
    if (!busy) {
      busy = await this.loadingCtl.create({
        message: "Please wait...",
        showBackdrop: false,
        duration: 5000,
      });
      console.log("[busy] refresh membership");
    }
    // busy.present().then(() => {
    // this.playerService.getPlayerMemberships()
    let _playerId
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      if (player.id) _playerId = player.id
      else if (player.playerId) _playerId = player.playerId
    });
    console.debug("list club membeships : ", this.player$, _playerId)
    let _activeCounter = 0;
    let _inactiveCounter = 0;
    this.flightService.getClubMembershipsForPlayer(_playerId)
      .subscribe((memberships: Array<ClubMembershipExtended>) => {
        // busy.dismiss(memberships);
        // busy.dismiss().then(() => {
        console.log("[Refresh] Membership : ", memberships)
        if (memberships) {
          this.memberships = memberships.sort((a: ClubMembershipExtended, b: ClubMembershipExtended) => {
            if (a.playerHomeClub && !b.playerHomeClub) return -1;
            else if (!a.playerHomeClub && b.playerHomeClub) return 1;
            else {
              if (a.club.name.toLowerCase() < b.club.name.toLowerCase()) return -1;
              else if (a.club.name.toLowerCase() > b.club.name.toLowerCase()) return 1;
              else return 0
            }

          });
          if(init) {
            if (memberships?.length > 1) {
              let pch = memberships.find((cm => cm.playerHomeClub));
              this.openClubMembershipPage(pch.club, pch.membershipNo, pch)
            } else {
              let pch = memberships[0]
              this.openClubMembershipPage(pch.club, pch.membershipNo, pch)
            }
          }
          this.clubIds = [];
          memberships.forEach((m: ClubMembershipExtended) => {
            this.clubIds.push(m.club.id);
          });
          // setTimeout(()=>{
          if (busy) busy.dismiss().then(() => {
            // this.refreshMygolfHandicap(busy);
            this.memberships?.forEach((cm)=>{
              if(this.filteredClubType === 'golfClub') {
                if (cm.status === 'Active' && !cm?.club?.virtualClub) _activeCounter++;
                if (cm.status !== 'Active' && !cm?.club?.virtualClub) _inactiveCounter++;
              } else if(this.filteredClubType === 'socialClub') {
                if (cm.status === 'Active' && cm?.club?.virtualClub) _activeCounter++;
                if (cm.status !== 'Active' && cm?.club?.virtualClub) _inactiveCounter++;
              } else {
                if (cm.status === 'Active') _activeCounter++;
                if (cm.status !== 'Active') _inactiveCounter++;
              }
            })
            console.debug("counter active : ", _activeCounter, "counter inactive : ", _inactiveCounter)
            if(_activeCounter === 0 && _inactiveCounter > 0)
              this.toggleStatus('Pending');
            else this.toggleStatus('Active');
            // if(_activeCounter >= _inactiveCounter) {
            //   this.toggleStatus('Active');
            // } else if(_activeCounter < _inactiveCounter) {
            //   this.toggleStatus('Pending');
            // }
          })
          // },300);

        }
        if (this.statusGetHCP) {
          MessageDisplayUtil.displayInfoAlert(this.alertCtl, "Success",
            "Handicap updated", "OK");
          this.statusGetHCP = false;
        }
        this.refreshing = false;
        // }) // busy
      }, (error) => {
        this.refreshing = false;
        busy.dismiss().then(() => {
            console.log("[Error] 1 : ", error)
            console.log("[Error] 2 : ", MessageDisplayUtil.getErrorMessage(error))

            if (error) {
              let msg = MessageDisplayUtil.getErrorMessage(error);
              MessageDisplayUtil.displayErrorAlert(this.alertCtl, "Membership",
                msg, "OK");
            }
          })
      }, () => {
        if(refresher) refresher.target.complete();
        this.refreshing = false;
        // this._refreshHcpIdxSubscriptions(busy);
      });
    // });
    // });
  }

  async openMembershipOptions(club: ClubInfo, membershipNo?: string, membership?: ClubMembershipExtended) {

    // this._selectClubMembership(membership);
    let prompt = await this.alertCtl.create({
      header: 'Club Membership',
      message: "Update your Membership Number and click Save",
      inputs: [
        {
          name: 'title',
          placeholder: 'Membership Number',
          value: membershipNo
        },
      ],
      buttons: [
        // {
        //   text: 'Select',
        //   handler: data => {
        //     prompt.dismiss();
        //     if (this.platform.is('ios') && this.platform.is('cordova')) {
        //       this.keyboard.hide();
        //     }
        //     this._selectClubMembership(membership);
        //     return false;
        //   }
        // },
        {
          text: 'Cancel',
          handler: data => {
            prompt.dismiss();
            if (this.platform.is('ios') && this.platform.is('cordova')) {
              this.keyboard.hide();
            }
            return false;
          }
        },
        {
          text: 'Save',
          handler: data => {
            prompt.dismiss()
              .then(() => {
                if (this.platform.is('ios') && this.platform.is('cordova')) {
                  this.keyboard.hide();
                }
                if (data && data.title) {
                  this._addMembership(club, data.title);
                }
              });
            return false;
          }
        }
      ]
    });
    prompt.present();
  }

  async deleteMembership(membership: ClubMembershipExtended) {
    let confirm = await this.alertCtl.create({
      header: "Delete Membership",
      message: "Do you want to delete your membership details for " +
        membership.club.name + "?",
      buttons: [
        {
          text: 'No',
          role: "cancel",
          handler: () => {
            confirm.dismiss();
            return false;
          }
        },
        {
          text: 'Delete',
          cssClass: "delete-item",
          role: "delete",
          handler: () => {
            confirm.dismiss()
              .then(() => {
                this._deleteClubMembership(membership);
              });
            return false;
          }
        }
      ]
    });
    confirm.present();
  }

  /**
   * Calls the server method delete the membership
   * @param membership
   * @private
   */
  private _deleteClubMembership(membership: ClubMembershipExtended) {
    // this.playerService.deleteClubMembership(membership.club.id)
    //     .subscribe(() => {
    //         this._refreshMemberships();
    //     });
    let _clubId = membership.club.id;
    let _membershipId = membership.id;
    this.flightService.deleteClubMembership(_clubId, _membershipId)
      .subscribe(() => {
        this._refreshMemberships();
      });
  }

  async setHomeClub(membership: ClubMembershipExtended) {

    let _message = {
      title: 'Set Home Club',
      content: 'Do you want to set <b>' + membership.club.name + '</b> as your home club?',
    }
    let modal = await this.modalCtl.create({
      // component: DeleteRoomModalComponent,
      component: CommonPullupMenuComponent,
      showBackdrop:true,
      mode:'ios',
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        // mode:'homeClub',
        // header:'Set Home Club',
        // msg:'Do you want to set <b>' + membership.club.name + '</b> as your home club?',
        // confirmBtn: 'Set Home',

        mode: 'messageSuccess',
        message: _message,
        // headerTitle: 'Set Home Club',
        // subTitle: 'Do you want to set <b>' + membership.club.name + '</b> as your home club?',
        firstBtnTxt: 'Set Home',
        secondBtnTxt: 'No'

      }
    });
    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data){
        console.debug("set home", data);
        this._setHomeclub(membership);
        // if(data?.data === 'confirm'){
        //   this._setHomeclub(membership);
        // }
      }
    })
  }

  private _setHomeclub(membership: ClubMembershipExtended) {
    console.debug("setting home club : ", membership)
    let _params = {
      membershipNo: membership.membershipNo,
      membershipType: membership && membership.membershipType ? membership.membershipType.typeId : null,
      joinedOn: membership.joinedOn,
      homeClub: true
    }

    this.playerService.updateClubMembership(membership.club.id,
      membership.membershipNo, true)
    .subscribe(() => {
      this._refreshMemberships();
    })
    // this.flightService.createUpdatePrimaryMembership(membership.club.id, membership.player.id, _params)
    //   .subscribe(() => {
    //     this._refreshMemberships();

    //   })
  }

  async refreshMygolfHandicap(busy?: any) {
    if(1) return;
    let _player;
    if (!busy) {
      busy = await this.loadingCtl.create({
        message: "Please wait...",
        showBackdrop: false,
        duration: 5000,
      });
      console.log("[busy] refresh m2u handicap ?");
    }
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      console.log("refresh mygolf handicap ", player)
      this.playerHcpSystem = player.defaultHandicapSystem
      _player = player;
    });
    this.handicapService.getHandicapHistory()
      .subscribe((data: any) => {
        console.log("[Handicap] data length: ", data.length)
        console.log("[Handicap] data", data)
        if (data.length > 0) {
          this.hasM2u = true;
          // this.playerHandicapHistory = data;
          this.handicapHistory = data[0];
          this.handicapService.getClubHandicap(data[0].player.playerId)
            .subscribe((data: Array<ClubHandicap>) => {
              this.clubHandicap = data;
              console.log("[Handicap] Club Handicap : ", this.clubHandicap)

              this.playerClubHcp = this.memberships;
              this.playerClubHcp.hcpDetail = [];
              if (data && data.length > 0) {
                this.memberships.forEach((m: ClubMembershipExtended) => {
                  this.clubHandicap.forEach((ch: any) => {

                    // console.log("[Handicap] - ", this.playerHcpSystem, " | CH : ",ch)
                    if (m.club.id === ch.clubInfo.clubId && ch.handicapSystem && ch.handicapSystem.id === this.playerHcpSystem) {
                      console.log("[Handicap] Club Handicap Membership")
                      m.hcpDetail = ch
                      console.log("[Handicap] M : ", m)
                      console.log("[Handicap] CH : ", ch)
                    } else if (m.club.id === ch.clubInfo.clubId && ch.handicapSystem && ch.handicapSystem.id.toLowerCase().includes('nhs')) {
                      m.nhsHcpDetail = ch;
                    }
                    // else {
                    //     m.hcpDetail = new ClubHandicap();
                    // }
                  })
                  console.log("[Handicap] Full m : ", m)
                  console.log("[Handicap] m.hcpDetail : ", m.hcpDetail)
                  this.playerClubHcp.hcpDetail.push(m.hcpDetail);

                })
              }

              this.refreshing = false;

              // console.log("[Handicap] playerClubHcp : ", this.playerClubHcp)
              // if (memberships) {
              //     this.memberships = memberships;
              //     this.clubIds     = [];
              //     memberships.forEach((m: ClubMembershipExtended) => {
              //         this.clubIds.push(m.club.id);
              //     });
              // }
              console.log("[Handicap] player hcp club :", this.playerClubHcp)
              // if(busy) busy.dismiss().then(()=>{
              // this._refreshHcpIdxSubscriptions(busy);
              // })



            }, (error) => {
              if (busy) busy.dismiss().then();

              this.refreshing = false;
            }, () => {
              if (busy) busy.dismiss().then();
              this.refreshing = false;
            })
        } else {
          this.playerClubHcp = this.memberships;
        }
      }, (error) => {
        this.handicapHistory = null; //new HandicapCalculation();
        this.hasM2u = false;
        this.refreshing = false;
      }, () => {
        if (busy) busy.dismiss().then();
        this.refreshing = false;
        // this.refreshHandicapSystem();
      })
  }

  hasM2uHandicap(): boolean {
    // console.log("[Handicap] Has m2u hcp :",this.hasM2u)
    return this.hasM2u;
  }

  private _addMembership(club: ClubInfo, membership: string) {
    console.debug("addd membership for club : ", club, membership)
    let _clubId = club?.id || club?.clubId;
    this.playerService.updateClubMembership(_clubId, membership)
      .subscribe(() => {
        this._refreshMemberships();
        // this.refreshMygolfHandicap();
      })
    // this.flightService.createUpdatePrimaryMembership(club.clubId,)
  }

  async openAddClubMembership() {
    let modal = await this.modalCtl.create({
      component: ClubListPage,
      componentProps: {
        openedModal: true,
        forMembership: true,
        filteredClubType: this.filteredClubType
      }
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("add club membership [0] ", data)
      if (!!data) {
        let _clubMembership;
        // this.openMembershipOptions(data);
        // this.getListClubMembershipTypes(data.clubId);
        if (this.hasM2uHandicap()) {
          this.playerClubHcp.filter((clubMembership: ClubMembershipExtended) => {
            return clubMembership.club.id === data.data.clubId || clubMembership.club.id === data?.data?.id
          }).map((clubMembership) => {
            _clubMembership = clubMembership;
          });
        } else {
          this.memberships.filter((clubMembership: ClubMembershipExtended) => {
            return clubMembership.club.id === data.data.clubId || clubMembership.club.id === data?.data?.id
          }).map((clubMembership) => {
            _clubMembership = clubMembership;
          });
        }
        if (_clubMembership) {
          this._selectClubMembership(_clubMembership);
        } else {
          this.checkMembershipType(data.data)
          .then((result: any)=>{
            console.debug("add club membership [1] ", _clubMembership, result)
            if(!result) {

            let _msg = 'This club currently have no Club Membership Types defined'
            MessageDisplayUtil.showErrorToast(_msg,
            this.platform, this.toastCtl, 3000, "bottom")
              // this.modalCtl.dismiss(false);
            this.modalCtl.dismiss(false);
            } else {
              this.openMembershipDetail(data.data);
            }
      })
        }


      }
      else {
        this.modalCtl.dismiss(false);
        // this.cancelGroup();
      }
      if (this.platform.is('ios') && this.platform.is('cordova')) {
        this.keyboard.hide();
      }
    });
    modal.present();
  }

  openClubMembershipPage(club: ClubInfo, membershipNo?: string, membership?: ClubMembershipExtended) {
    this._selectClubMembership(membership);
  }

  getListClubMembershipTypes(clubId: number) {
    let _params = {};
    if (clubId) _params['clubId'] = clubId;
    this.flightService.getListClubMembershipTypes(_params)
      .subscribe((data) => {
        if (data) {
          console.debug("club membership types : ", data)
        }
      })
  }

  onEditMembershipDetail(membership, clubInfo) {
    this.openMembershipDetail(clubInfo, true, membership);
  }

  async openMembershipDetail(clubInfo: any, editMode: boolean = false, membership?: ClubMembershipExtended) {
    let _editMode = editMode;
    let _player;
    this.player$.pipe(take(1)).subscribe((player: PlayerInfo) => {
      _player = player;
    });
    let modal = await this.modalCtl.create({
      component: PlayerAddClubMembershipPage,
      componentProps: {
        clubInfo: clubInfo,
        player: this.player$,
        editMode: editMode,
        clubMembership: membership,
      }
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("membership detail dismiss", data)
      if (!!data && data?.data?.membership && !_editMode) {
        this._selectClubMembership(data.membership);
      }
      if(data) {
        // this.filteredClubType = 'all';
        if(data?.data?.membership?.club?.virtualClub)
          this.filteredClubType = 'socialClub'
        else if(!data?.data?.membership?.club?.virtualClub)
          this.filteredClubType = 'golfClub';
        else this.filteredClubType = 'all';
        // if(!_editMode)
          this.currentStatus = 'Pending';
        this._refreshMemberships();
      } else {
        this.modalCtl.dismiss();
      }
    });
    modal.present();
    // this.nav.push(AddClubMembershipPage, {
    //     clubInfo: clubInfo,
    //     player: _player,
    //     editMode: false
    // })
  }

  currentStatus: string = 'Active';
  toggleStatus(data: string) {
    if (!data) return
    this.currentStatus = data;
  }


  async moreActionMenu(membership: ClubMembershipExtended, club: ClubInfo, value ? : any) {
    console.debug("club membership extended", membership)
    const modal = await this.modalCtl.create({
      component: TrasactionModalComponent,
      mode: 'ios',
      showBackdrop:true,
      swipeToClose:true,
      cssClass: this.platform.is('mobile') ? 'self-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps: {
        isFrom: 'membershipMenu',
        isHomeClub: membership?.playerHomeClub,
      }
    })
    modal.present();
    modal.onDidDismiss().then((data) => {
      if (data?.data) {
        switch (data?.data) {
          case 'setHome':
            this.setHomeClub(membership)
            break;
          case 'unsetHome':
            this.unsetHomeClub(membership)
            break;
          case 'updateMshipNo':
            if(this.currentStatus === 'Active') {
              MessageDisplayUtil.showMessageToast('Your membership has been approved. Should you encounter any errors with your membership number, kindly notify the Club for correction',
              this.platform, this.toastCtl, 5000, 'bottom');
            } else {
              this.openMembershipOptions(club, value)
            }
          break;
          case 'viewStat':
            // this.openMembershipOptions(club, value)
            this.viewClubStatement(membership);
            break;
          case 'makePayment':
            // this.onClickMakePayment(membership);
            break;
          case 'delete':
            this.deleteMembership(membership)
            break;
          case 'viewMship':
            this._selectClubMembership(membership);
            break;
          case 'updateMshipInfo':
            this.onEditMembershipDetail(membership, club)
            break;
        }

      }
    })
  }


  async unsetHomeClub(membership: ClubMembershipExtended) {
    let modal = await this.modalCtl.create({
      component: DeleteRoomModalComponent,
      showBackdrop:true,
      mode:'ios',
      cssClass: this.platform.is('mobile') ? 'self-favorite-adjustable-modal' : 'self-adjustable-modal-desktop',
      componentProps:{
        mode:'homeClub',
        header:'Unset Home Club',
        msg:'Do you want to unset <b>' + membership.club.name + '</b> from your home club?',
        confirmBtn:'Unset Home'
      }
    });
    await modal.present();
    modal.onDidDismiss().then((data)=>{
      if(data){
        if(data?.data === 'confirm'){
          this._unsetHomeClub(membership);
        }
      }
    })
  }

  private _unsetHomeClub(membership: ClubMembershipExtended) {
    console.debug("setting home club : ", membership)
    let _params = {
      membershipNo: membership.membershipNo,
      membershipType: membership && membership.membershipType ? membership.membershipType.typeId : null,
      joinedOn: membership.joinedOn,
      homeClub: true
    }

    this.playerService.updateClubMembership(membership.club.id,
      membership.membershipNo, false)
    .subscribe(() => {
      this._refreshMemberships();
    })
    // this.flightService.createUpdatePrimaryMembership(membership.club.id, membership.player.id, _params)
    //   .subscribe(() => {
    //     this._refreshMemberships();

    //   })
  }

  async onChangeClubType() {

    let _dataList = [{
      id: 'golfClub',
      name: 'Golf Club',
      // iconUrl: 'assets/icons/book.png'
    },{
      id: 'socialClub',
      name: 'Social Club',
      // iconUrl: 'assets/icons/golf-field.png'
    },{
      id: 'all',
      name: 'Both',
      // iconUrl: 'assets/icons/golf-website.png'
    }]
      const modal = await this.modalCtl.create({
        mode: 'ios',
        component: CommonPullupMenuComponent,
        cssClass: 'self-adjustable-modal',
        componentProps: {
            app: null,
            dataList: _dataList,
            mode: 'common',
            headerTitle: 'Filter by Golf or Social Club',
            selectedValue: this.filteredClubType
            // subTitle: this.leagueRounds?this.leagueRounds[0].seasonName:'',
        }
    })
    await modal.present().then(() => {
        const height = this.platform.height() - 250;
        document.getElementsByClassName('inner-content')[0]['style'].maxHeight = `${height}px`;
    });
    modal.onDidDismiss().then((data: any) => {
      console.debug("pullup dismiss", data)
      if(data) {
        this.filteredClubType = data.data.id;
      }
      // if(data)

    })
  }

  parseFilteredClubType() {
    if(this.filteredClubType === 'all') {
      return 'Both';
    } else if(this.filteredClubType === 'golfClub') {
      return 'Golf Club'
    } else if(this.filteredClubType === 'socialClub') {
      return 'Social Club'
    } else return 'Both';
  }

  getFilteredMemberships() {
    console.debug("filtered membership ", this.memberships, this.filteredClubType)
    // if(!this.playerClubHcp) return [];
    if(!this.memberships) return [];

    // let _filtered = this.playerClubHcp;
    let _filtered = this.memberships;


    if(this.memberships?.length > 0)
      _filtered = this.memberships.filter((cm: ClubMembershipExtended)=>{
        if(this.filteredClubType === 'golfClub')
          return !cm?.club?.virtualClub // && await this.getFilteredStatus(cm.status)
        else if(this.filteredClubType === 'socialClub')
          return cm?.club?.virtualClub //&& await this.getFilteredStatus(cm.status)
        else return true; // await this.getFilteredStatus(cm.status);
      })

    _filtered = _filtered.filter((cm: ClubMembershipExtended)=>{
      if(this.currentStatus?.toLowerCase() === 'active') return cm?.active;
      else return !cm.active;
    })
    console.debug("filtered membership [1] ", _filtered)
    return _filtered;
  }

  checkMembershipType(clubInfo: any) {
    return new Promise((resolve, reject)=>{
      let _clubId = clubInfo?.clubId || clubInfo?.id;
      let _params = {
        clubId: _clubId
      }
      let _
      this.flightService.getListClubMembershipTypes(_params)
      .subscribe((data: Array<ClubMembershipType>) => {
        console.debug("membership type", data)
        resolve(data?.length>0)
      });});
  }

  viewClubStatement(membership) {

    this.modalCtl.dismiss({
      mode: 'viewStat',
      membership: membership
    });
  }

  onRefreshClick(refresher) {
    this._refreshMemberships(null,refresher);
  }

  getFilteredStatus(status: string) {
    console.debug("get filtered status ", status, this.currentStatus)
    let _status = status.toLowerCase();
    let _currentStatus = this.currentStatus.toLowerCase();
    console.debug("get filtered status ", _status, _currentStatus)
    if(_currentStatus === 'active')
      return _status === 'active';
    else return true
    // if(_currentStatus === 'pending') {
    //   return _status === 'pending' || _status === 'inactive';
    // } else return _status === _currentStatus
  }


}
